import { OrganizationKeyName } from "../../../model/Organization";

export const UPSERT_PRODUCT_ADDITION = "SHOP:UPSERT_PRODUCT_ADDITION";

export const upsertProductAdditionAction = (
  organization: OrganizationKeyName,
  data: any,
  id?: string
) => ({
  type: UPSERT_PRODUCT_ADDITION as typeof UPSERT_PRODUCT_ADDITION,
  organization,
  data,
  id,
});

export type UpsertProductAdditionAction = ReturnType<
  typeof upsertProductAdditionAction
>;
